var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: (_vm.height || 80) + 'px' })},[_c('VueC3',{attrs:{"handler":_vm.handler}}),(_vm.showLoading)?_c('div',[_vm._v(_vm._s(_vm.$t('loading')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }